import Button from "../Shared/Button";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

const PatientWorkflowSearchingTable = ({ selectedPatient, onSelectPatient }) => {
  const [searchPatientName, setSearchPatientName] = useState("");
  const [patientRows, setPatientRows] = useState([]);
  const [isSearchingPatients, setIsSearchingPatients] = useState(false);
  const [failureReason, setFailureReason] = useState(null);

  const practitioners = useSelector((state) => state.app.practitioners);
  const clientAppointments = useSelector((state) =>
    state.workflow.clientAppointments
      .concat(state.workflow.historyClientAppointments)
      .concat(state.workflow.archivedClientAppointments)
  );

  const handleSearchPatients = async () => {
    setIsSearchingPatients(true);
    const [firstName, lastName] = searchPatientName
      .trim()
      .toLowerCase()
      .split(" ")
      .filter((component) => !_.isEmpty(component));

    let workflows = [];
    if (firstName && lastName) {
      workflows = _.filter(
        clientAppointments,
        (ca) =>
          ca.client?.firstName?.toLowerCase().includes(firstName) &&
          ca.client?.lastName?.toLowerCase().includes(lastName) &&
          ca.appointment?.startDateTime &&
          ca.appointment?.startDateTime.includes("T")
      );
    } else if (firstName) {
      workflows = _.filter(
        clientAppointments,
        (ca) =>
          ca.client?.firstName?.toLowerCase().includes(firstName) &&
          ca.appointment?.startDateTime &&
          ca.appointment?.startDateTime.includes("T")
      );
    }

    setPatientRows(
      workflows.map((ca) => {
        const practitioner = _.find(
          practitioners,
          (practitioner) => practitioner.practitionerId === ca.appointment?.practitioner?.practitionerId
        );
        const practitionerFullName = `${_.get(practitioner, "firstName", "")} ${_.get(practitioner, "lastName", "")}`;
        return {
          workflowId: ca.id,
          fullName: `${ca.client?.firstName ?? ""} ${ca.client?.lastName ?? ""}`,
          appointmentDate:
            ca.appointment?.startDateTime && ca.appointment?.startDateTime.includes("T")
              ? ca.appointment?.startDateTime.split("T")[0]
              : "",
          practitionerFullName,
        };
      })
    );
    setIsSearchingPatients(false);
  };

  return (
    <>
      <div className="field has-addons">
        <div className="control is-expanded">
          <input
            className="input is-radiusless is-size-7"
            type="text"
            placeholder="Search client by entering client's name here"
            value={searchPatientName}
            onChange={(e) => {
              setFailureReason(null);
              setSearchPatientName(e.target.value);
            }}
            onKeyPress={(e) => {
              if (e.which === 13) {
                handleSearchPatients();
              }
            }}
          />
        </div>
        <div className="control">
          <Button text="Search" onClick={handleSearchPatients} isLoading={isSearchingPatients} />
        </div>
      </div>
      <p className="has-text-danger">{failureReason}</p>
      <div className="table-container apt-table">
        <table className="table is-fullwidth is-stripe is-hoverable is-scrollable is-size-7">
          <thead>
            <tr>
              <th>Fullname</th>
              <th>Practitioner</th>
              <th>Appointment Date</th>
              <th>Workflow Id</th>
            </tr>
          </thead>
          <tbody>
            {patientRows.length === 0 && (
              <tr>
                <td>No results</td>
              </tr>
            )}
            {patientRows.map((row) => (
              <tr
                key={row.workflowId}
                className={`${row.workflowId === selectedPatient?.workflowId ? "is-active " : ""}is-hovered`}
                onClick={() => onSelectPatient(row)}
              >
                <td>{row.fullName}</td>
                <td>{row.practitionerFullName}</td>
                <td>{row.appointmentDate}</td>
                <td>{row.workflowId}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PatientWorkflowSearchingTable;
